<template>
  <div class="rt-footer-wrapper"><slot /></div>
</template>

<script>
export default {
  name: 'RtFooter'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtFooter.vue?49184dc9